module.exports = __webpack_public_path__ + "static-portal/img/news6-2.3fe5480.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news6-2.png
// module id = X6Na
// module chunks = 4